import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/LocalNavbar.css";

const LocalNavbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const handleProjectClick = (e) => {
        e.preventDefault();
        window.location.href = "/#projects";
        setMenuOpen(false);
    };

    const handleMenuToggle = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <div className="localnavbar">
            {/* Mobile menu icon */}
            <div className="menu-icon" onClick={handleMenuToggle}>
                <span>&#9776;</span>
            </div>

            {/* Menu links */}
            <div className={`nav-links ${menuOpen ? "open" : ""}`}>
                <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
                <a href="/#projects" onClick={handleProjectClick}>Projects</a>
                <Link to="/aboutme" onClick={() => setMenuOpen(false)}>About Me</Link>
            </div>
        </div>
    );
};

export default LocalNavbar;
